import { UserData } from '../../../../../types';

export type LivingSituation = 'homeowner' | 'renter' | 'neither' | '';
export type YesNo = 'yes' | 'no' | '';

export interface AutoFillableFields {
  firstName?: string;
  lastName?: string;
  email?: string;
  dateOfBirth?: string;
  dependents?: YesNo;
  livingSituation?: LivingSituation;
  married?: YesNo;
  userId?: string;
}

function formatAutoFillableFields(
  userData: UserData | undefined
): AutoFillableFields {
  if (!userData) {
    return {};
  }

  let autoFillableFields: AutoFillableFields = {
    firstName: userData.first_name || '',
    lastName: userData.last_name || '',
    email: userData.email_address || '',
    userId: userData.user_id || '',
  };

  if (userData.hasOwnProperty('date_of_birth')) {
    autoFillableFields.dateOfBirth = formatDateOfBirth(userData.date_of_birth);
  }

  if (userData.hasOwnProperty('has_kids')) {
    autoFillableFields.dependents = userData.has_kids ? 'yes' : 'no';
  }

  if (userData.hasOwnProperty('housing_situation')) {
    autoFillableFields.livingSituation = formatHousingSituation(
      userData.housing_situation
    );
  }

  if (userData.hasOwnProperty('marital_status')) {
    autoFillableFields.married =
      userData.marital_status === 'Married' ? 'yes' : 'no';
  }

  return autoFillableFields;
}

function formatDateOfBirth(dateOfBirth: string) {
  if (!dateOfBirth) {
    return '';
  }

  const newDate = new Date(dateOfBirth);
  const month = ('0' + (newDate.getMonth() + 1)).slice(-2);
  const day = ('0' + (newDate.getDate() + 1)).slice(-2);
  const year = newDate.getFullYear();

  return `${month}/${day}/${year}`;
}

function formatHousingSituation(housingSituation: string): LivingSituation {
  if (!housingSituation) {
    return '';
  }

  if (housingSituation === 'Renting') {
    return 'renter';
  }

  if (housingSituation === 'Mortgage' || housingSituation === 'Paid Off Home') {
    return 'homeowner';
  }

  return '';
}

export { formatAutoFillableFields };
